import React from "react";
import { Link } from "react-router-dom";
import "./Galleria.css";

import uno from "../assets/cassandra/1.jpg";
import due from "../assets/cassandra/2.jpeg";
import tre from "../assets/cassandra/3.jpg";
import quattro from "../assets/cassandra/4.jpeg";
import cinque from "../assets/cassandra/5.jpeg";
import sei from "../assets/cassandra/6.jpeg";
import sette from "../assets/cassandra/7.jpg";
import otto from "../assets/cassandra/8.jpg";

const opere = [
  { img: uno, titolo: "PORT'ALBA", righe: ["NAPOLI"] },
  { img: due, titolo: "SASSARI", righe: [] },
  { img: tre, titolo: "NAPOLI", righe: [] },
  { img: quattro, titolo: "TORINO", righe: [] },
  { img: cinque, titolo: "TITO", righe: [] },
  { img: sei, titolo: "FIRENZE", righe: [] },
  { img: sette, titolo: "T-SHIRT PERSONALIZZATE", righe: ["CASSANDRA PARLA ©"] },
  { img: otto, titolo: "TOTE BAG PERSONALIZZATE", righe: ["CASSANDRA PARLA ©"] },
];

const Cassandra = () => {
  return (
    <div className="galleria">
      {opere.map((o, i) => (
        <figure className="opera" key={i}>
          <img src={o.img} alt={o.titolo} draggable="false" />
          <figcaption className="didascalia">
            <strong>{o.titolo}</strong>
            {o.righe.map((r, j) => (
              <span key={j}>{r}</span>
            ))}
          </figcaption>
        </figure>
      ))}

      <div className="opera-testo">
        <p>
          Cassandra Parla, progetto di street-art nato nel cuore di Napoli,
          nasce dall’idea di un’arte condivisa e si diffonde successivamente in
          tutta Italia. Rivendicare i diritti umani è il messaggio che esprimono
          i miei dipinti, affissi come manifesti sui muri delle città, nella
          speranza di incontrare occhi in cui rispecchiarsi. “M’he fatt ‘a piezz
          pe’ nun m’affruntà sana” apre questo progetto che parla napoletano, la
          lingua della mia terra, nell’intenzione di restituire a Napoli, ciò
          che Napoli ha donato alla mia arte.
        </p>
      </div>

      <Link to="/Home" className="torna">
        Torna alla home
      </Link>
    </div>
  );
};

export default Cassandra;
